import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/crm/" });

export const CRMService = {
  createLead: (lead) => {
    return api.post("/leads", lead);
  },
  getLeads: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/leads?${params.toString()}`);
  },

  getLead: (id) => {
    return api.get(`/leads/${id}`);
  },

  updateLead: (id, leadData) => {
    return api.patch(`/leads/${id}`, leadData);
  },

  deleteLead: (id) => {
    return api.delete(`/leads/${id}`);
  },

  updateLeadActivity: (id, activity) => {
    return api.patch(`/leads/${id}/activity`, activity);
  },

  getLeadStatuses: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/lead-statuses?${params.toString()}`);
  },

  getLeadPriorities: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/lead-priorities?${params.toString()}`);
  },

  getLeadStatusById: (id) => {
    return api.get(`/lead-statuses/${id}`);
  },

  createLeadStatus: (statusData) => {
    return api.post("/lead-statuses", statusData);
  },

  updateLeadStatus: (id, statusData) => {
    return api.patch(`/lead-statuses/${id}`, statusData);
  },

  deleteLeadStatus: (id) => {
    return api.delete(`/lead-statuses/${id}`);
  },

  createClient: (clientData) => {
    return api.post("/clients", clientData);
  },

  getClientList: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/clients?${params.toString()}`);
  },

  getClientById: (clientId) => {
    return api.get(`/clients/${clientId}`);
  },

  updateClient: (clientId, clientData) => {
    return api.put(`/clients/${clientId}`, clientData);
  },

  deleteClient: (clientId) => {
    return api.delete(`/clients/${clientId}`);
  },

  createClientReceivables: (clientId, data) => {
    return api.post(`/clients/${clientId}/receivables`, data);
  },

  getClientReceivablesById: (receivablesId) => {
    return api.get(`/clients/receivables/${receivablesId}`);
  },

  updateClientReceivables: (clientId, receivablesId, data) => {
    return api.put(`/clients/${clientId}/receivables/${receivablesId}`, data);
  },

  deleteClientReceivables: (clientId, receivablesId) => {
    return api.delete(`/clients/${clientId}/receivables/${receivablesId}`);
  },

  createClientInvoice: (clientId, data) => {
    return api.post(`/clients/${clientId}/invoices`, data);
  },

  getClientInvoices: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/clients/invoices?${params.toString()}`);
  },

  getClientInvoiceById: (invoiceId) => {
    return api.get(`/clients/invoices/${invoiceId}`);
  },

  updateClientInvoice: (invoiceId, data) => {
    return api.put(`/clients/invoices/${invoiceId}`, data);
  },

  deleteClientInvoice: (invoiceId) => {
    return api.delete(`/clients/invoices/${invoiceId}`);
  },
};
